require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/es6.array.species.js
// module id = N/Yk
// module chunks = a74a